export default "__VITE_ASSET__CdfYtylx__"